import type { ReactElement } from 'react';
import { useDefaultErrorHandling } from 'components/technical/UseDefaultErrorHandling';
import { useTransactionFilterInputQuery } from '../../../generated/graphql';
import { TransactionList } from './list/TransactionList.tsx';

const TransactionDashboard = (): ReactElement => {
  const { data, Fallback, loaded } = useDefaultErrorHandling(useTransactionFilterInputQuery());

  if (!loaded) {
    return <Fallback />;
  }

  // const existingTags = data?.bookkeeping.transactionTags ?? [];
  return (
    <TransactionList accounts={data.portfolio.accounts} subFunds={data.portfolio.subFunds.list} existingTags={[]} />
  );
};

export default TransactionDashboard;
